import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.post('/customer-api/customer/attachment/page', params)

export const getDetailedData = params =>
  request.post(`/customer-api/customer/attachment/selectById`, params)

export const noteTypeList = [
  {
    id: 0,
    name: 'Other',
  },
  {
    id: 1,
    name: 'Collateral',
  },
  {
    id: 2,
    name: 'Insurance',
  },
  {
    id: 3,
    name: 'Financial Report',
  },
  {
    id: 4,
    name: 'Line Of Credit',
  },
]

export const remove = id =>
  request.get(`/customer-api/customer/attachment/delete/${id}`)

export const download = id =>
  request.get(
    `/customer-api/customer/attachment/download/${id}`,
    {},
    {
      responseType: 'blob',
    },
  )

export const getEdit = params =>
  request.post(`/customer-api/customer/attachment/upload`, params)
